import { Theme } from '@mui/material'

import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()((theme: Theme) => ({
  container: {
    display: 'flex',
    gap: theme.spacing(4),
    padding: theme.spacing(5, 4, 0, 4),
  },
  formWidth: {
    width: '70%',
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
  },
  stickyHeader: {
    position: 'sticky',
    top: 100,
    zIndex: 10,
  },
  activityLogWidth: {
    width: '30vw',
  },
  hideActivityLog: {
    display: 'block',
  },
  sectionText: {
    fontSize: '12px !important',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '16px !important',
    letterSpacing: '0.25px',
    color: theme.palette.labraText.description,
    fontFamily: theme.typography.fontFamily,
    textAlign: 'left',
  },
  contentWrapper: {
    backgroundColor: theme.palette.text.white,
    padding: theme.spacing(2),
    borderRadius: theme.spacing(1),
    display: 'flex',
    justifyContent: 'space-between',
  },
  headingWrapper: { display: 'flex', gap: theme.spacing(2) },
  downloadButton: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  videoContainer: {
    width: 'fit-content',
    textAlign: 'left',
    display: 'flex',
  },
  thumbnailImages: {
    width: '240px',
    height: '135px',
    cursor: 'pointer',
    borderRadius: theme.spacing(0.5),
    display: 'block',
    margin: 'auto',
  },
  videoWrapper: {
    backgroundColor: theme.palette.grey[100],
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    padding: theme.spacing(2),
    gap: theme.spacing(2),
    borderRadius: theme.spacing(1),
    width: '-webkit-fill-available  ',
    maxHeight: '239px',
    alignSelf: 'center',
  },
  thumbnailWrapper: {
    position: 'relative',
    display: 'inline-block',
  },
  helpContainer: {
    backgroundColor: theme.palette.text.white,
    padding: theme.spacing(2),
    borderRadius: theme.spacing(1),
    display: 'flex',
  },
  infoIcon: {
    height: theme.spacing(2),
    width: theme.spacing(2),
    fontSize: '16px',
  },
  downloadIcon: {
    height: theme.spacing(2.25),
    width: theme.spacing(2.25),
    color: theme.palette.button.primary,
  },
  qAndAParentWrapper: {
    display: 'flex',
  },
  playButton: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    cursor: 'pointer',
    opacity: '0.19',
    color: theme.palette.black.dark,
  },
  sidePanelInfoIcon: {
    width: '24px',
    height: '20px',
    fontSize: '24px',
  },
  sidePanelTitleText: {
    fontSize: '22px',
    lineHeight: '28px',
  },
  listingWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
  },
  loadingSpinner: {
    color: `${theme.palette.labraText.primary} !important`,
    width: '20px !important',
    height: '20px !important',
    marginLeft: 'auto',
    marginRight: 'auto',
    opacity: 1,
  },
  bottomMargin: { marginBottom: '32px' },
  stickyRightSection: {
    position: 'sticky',
    top: 100,
    zIndex: 10,
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
  },
  demoVideoContainer: {
    backgroundColor: theme.palette.stages.default,
    padding: '16px',
    borderRadius: '10px',
  },

  playIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '28px',
    height: '28px',
    borderRadius: '6px',
    backgroundColor: theme.palette.grey[100],
  },

  videoText: {
    fontSize: '14px',
    fontWeight: 500,
    color: theme.palette.black.dark,
    alignItems: 'left',
  },
  videoHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    marginBottom: '16px',
  },
}))
